import React, { useState } from 'react';
import Button from '../../../../../common/Button';
import { Modal, notification } from 'antd';
import { Formik, ErrorMessage } from 'formik';
import Form from 'formik-antd/lib/form';
import SubmitButton from '../../../../../common/SubmitButton';
import { string, object } from 'yup';
import Api from '../../../../services/Api';
import {
  Flex,
  FieldError,
  openNotificationWithIcon,
  useFetch,
  User,
} from '@mss/mss-component-library';

import Select from 'formik-antd/lib/select';
import { useTranslation } from 'react-i18next';
type AddUserModalProps = {
  closeModal: () => void;
  groupId: string;
  fetchGroupMembers: () => void;
};

export default function AddUserModal({
  groupId,
  closeModal,
  fetchGroupMembers,
}: AddUserModalProps) {
  const [filteredUsers, setFilteredUsers] = useState<any[]>([]);
  const [t] = useTranslation(['authorization', 'common']);
  const [users] = useFetch({
    url: `/api/user/`,
    defaultValue: [],
    onSucces: ({ data }) => {
      setFilteredUsers(
        data
          .filter((x: User) => !x.groups.includes(parseInt(groupId)))
          .map((y: User) => {
            const hasName = y.first_name || y.last_name;
            return {
              key: y.id,
              value: y.id,
              label: hasName ? `${y.first_name} ${y.last_name}` : y.email,
            };
          })
      );
    },
  });

  return (
    <Modal
      title={t(`Add user to this group`)}
      visible
      closable={false}
      footer={[
        <Button ghost variant="primary" onClick={closeModal}>
          {t('Cancel')}
        </Button>,
      ]}
    >
      <p>
        {t(
          'Use the dropdown below to select a user you would like to add to this group.'
        )}
      </p>
      <Formik
        onSubmit={async (values: any) => {
          const result = await Api.group.user.add({
            user: values.user,
            group: parseInt(groupId),
          });
          if (result.status >= 200 && result.status < 300) {
            openNotificationWithIcon(
              notification.success,
              t('User added'),
              t('User successfully added to the group.')
            );
            fetchGroupMembers();
            closeModal();
          } else {
            openNotificationWithIcon(
              notification.error,
              t('Adding user failed'),
              t(
                'Due to technical issues the user could not be added to the group. Please try again later.'
              )
            );
          }
        }}
        initialValues={{ user: '' }}
        validationSchema={object().shape({
          user: string().required(t('Please select a user')),
        })}
      >
        {({ values, errors }) => {
          return (
            <Form>
              <Flex h="between" v="center">
                <Select
                  name="user"
                  placeholder={t('Select a user')}
                  value={values.user}
                  data-ta="groupUserSelect"
                  optionFilterProp={'children'}
                  disabled={users.loading}
                  style={{ width: 375 }}
                  showSearch
                  autoFocus
                >
                  {filteredUsers.map(x => (
                    <Select.Option key={x.key} value={x.value}>
                      {x.label}
                    </Select.Option>
                  ))}
                </Select>
                <SubmitButton
                  disabled={!!errors.user || !values.user}
                  style={{ flex: '0 0 80px' }}
                >
                  Add
                </SubmitButton>
              </Flex>
              <FieldError>
                <ErrorMessage name={'name'} />
              </FieldError>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
}
